<template>
  <!-- 邀请成员加入组织发送的短信 打开的页面 -->
  <div class="wrapper" v-loading="loading">
    <div class="header">
      <img class="logoIcon" src="@/assets/images/yto-logo-white.png"/>
    </div>
    <div class="content">
      <div class="shadow" v-if="!loading">
        <template v-if="!errMsg">
          <div class="text">
            用户
            <span class="y-fc-4C84FF y-f-b">{{ currentMobile }}</span>
            邀请您加入他的组织，请点击下方按钮进行确认。
          </div>
          <div class="y-t-ac">
            <el-button class="y-mt-20" @click="handleClick" size="mini" type="primary">确定加入组织</el-button>
          </div>
        </template>
        <div class="text" v-else>
          {{ errMsg }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addConfirmApi, getSmsInfoApi } from '@/api/systemModule/inviteMember';

export default {
  data() {
    return {
      currentMobile: '',
      errMsg: '',
      loading: false,
      randomNum: '',
    }
  },
  mounted() {
    this.getSmsInfo();
  },
  methods: {
    getSmsInfo() {
      let params = {
        randomNum: this.$route.query.f
      }
      this.loading = true;
      getSmsInfoApi(params).then(res => {
        if(res.success) {
          this.currentMobile = res.data.currentMobile;
          this.randomNum = res.data.randomNum;
          this.errMsg = '';
        } else {
          this.errMsg = res.message;
        }
        this.loading = false;
      }).catch(() => {
        this.errMsg = '邀请链接已失效，请联系管理员重新邀请，若已加入组织，请忽略。';
        this.loading = false;
      })
    },
    handleClick() {
      // 确定加入组织
      let params = {
        randomNum: this.randomNum
      }
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      addConfirmApi(params).then(res => {
        if(res.success) {
          this.errMsg = '加入组织成功。';
        } else {
          this.errMsg = res.message;
        }
        loadingMask.close()
      }).catch(() => {
        loadingMask.close()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../styles/variables";
.wrapper {
  background-color: #f5f5f5;
  height: 100vh;
}
.header {
  background-color: $blue-style;
  .logoIcon {
    height: 50px;
  }
}
.content {
  padding-top: 30px;

  .shadow {
    padding: 10px;
    box-shadow: 0px 0px 17px 0px rgba(0, 0, 0, 0.1);
    width: 90%;
    margin: 0 auto;
    background-color: #fff;
    .text {
      font-size: 13px;
      line-height: 20px;
    }
  }
}
</style>
